module.exports = __webpack_public_path__ + "668c3cdd7c03639d2fa5c0da2a0335a4.svg";